import { useState, useEffect, useCallback } from "react";
import { PageHeader } from "../../page-header";
import { TbHistory, TbSearch, TbUser, TbPackage, TbCheck, TbAlertTriangle } from "react-icons/tb";
import { apiV1 } from "../../../lib/axios";
import "../PagamentoLote.css";
import "./PagamentoLoteHistorico.css";

const MOCK_HISTORICO = [
  { id: 1, dataHora: "23/04/2026 09:12", usuario: "João Silva",    acao: "Criou lote",        detalhe: "#20260423-001 — 8 contas | R$ 14.320,00" },
  { id: 2, dataHora: "23/04/2026 09:18", usuario: "Sistema",       acao: "Validou contas",    detalhe: "2 alertas encontrados no lote #20260423-001" },
  { id: 3, dataHora: "23/04/2026 10:05", usuario: "Maria Gestora", acao: "Aprovou lote",      detalhe: "#20260423-001 — 6 contas aprovadas" },
  { id: 4, dataHora: "23/04/2026 10:08", usuario: "Maria Gestora", acao: "Liberou pagamento", detalhe: "6 contas selecionadas — R$ 11.870,00" },
  { id: 5, dataHora: "24/04/2026 08:45", usuario: "Carlos Fin.",   acao: "Criou lote",        detalhe: "#20260424-001 — 5 contas | R$ 9.750,00" },
  { id: 6, dataHora: "24/04/2026 09:00", usuario: "Sistema",       acao: "Validou contas",    detalhe: "Nenhum alerta encontrado no lote #20260424-001" },
  { id: 7, dataHora: "24/04/2026 11:30", usuario: "Maria Gestora", acao: "Liberou pagamento", detalhe: "5 contas selecionadas — R$ 9.750,00" },
  { id: 8, dataHora: "25/04/2026 14:22", usuario: "João Silva",    acao: "Adicionou conta",   detalhe: "Fornecedora Alfa Ltda — Boleto NF-1008 — R$ 3.200,00" },
  { id: 9, dataHora: "28/04/2026 08:00", usuario: "Carlos Fin.",   acao: "Criou lote",        detalhe: "#20260428-001 — 3 contas | R$ 6.100,00" },
  { id: 10,dataHora: "28/04/2026 08:15", usuario: "Sistema",       acao: "Validou contas",    detalhe: "1 alerta encontrado no lote #20260428-001" },
];

const ACTION_ICONS = {
  "Criou lote":         <TbPackage size={14} />,
  "Validou contas":     <TbAlertTriangle size={14} />,
  "Liberou pagamento":  <TbCheck size={14} />,
  "Aprovou lote":       <TbCheck size={14} />,
  "Rejeitou lote":      <TbAlertTriangle size={14} />,
  "Adicionou conta":    <TbUser size={14} />,
};

const ACTION_COLOR = {
  "Criou lote":        "blue",
  "Validou contas":    "orange",
  "Liberou pagamento": "green",
  "Aprovou lote":      "green",
  "Rejeitou lote":     "red",
  "Adicionou conta":   "blue",
};

export default function PagamentoLoteHistorico() {
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filterUser, setFilterUser] = useState("");
  const [filterAction, setFilterAction] = useState("");

  const fetchHistorico = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (search)       params.append("search",  search);
      if (filterUser)   params.append("usuario", filterUser);
      if (filterAction) params.append("acao",    filterAction);
      const response = await apiV1.get(`/batch-payments/history?${params.toString()}`);
      setHistorico(response.data.data || []);
    } catch (err) {
      console.error("Erro ao carregar histórico:", err);
    } finally {
      setLoading(false);
    }
  }, [search, filterUser, filterAction]);

  useEffect(() => {
    fetchHistorico();
  }, [fetchHistorico]);

  return (
    <div className="paylote-page">
      <div className="paylote-inner col-md-10 m-auto mt-4">
        <div className="mb-3">
          <PageHeader
            title="Histórico"
            pages={[
              { name: "Pagamento em Lote", href: "/pagamento-lote/dashboard" },
              { name: "Histórico" },
            ]}
          />
        </div>

        {/* Filtros */}
        <div className="paylote-table-card paylote-hist-filter-bar mb-4">
          <div className="paylote-hist-filter-row">
            {/* Busca */}
            <div className="paylote-form-field paylote-hist-field">
              <label className="paylote-label">Buscar</label>
              <div className="paylote-hist-search-wrap">
                <input
                  className="paylote-input paylote-hist-search-input"
                  placeholder="Lote, usuário, detalhe…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* Filtro usuário */}
            <div className="paylote-form-field paylote-hist-field-sm">
              <label className="paylote-label">Usuário</label>
              <input
                className="paylote-input"
                placeholder="Nome do usuário"
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
              />
            </div>

            {/* Filtro ação */}
            <div className="paylote-form-field paylote-hist-field-sm">
              <label className="paylote-label">Tipo de ação</label>
              <select
                className="paylote-select"
                value={filterAction}
                onChange={(e) => setFilterAction(e.target.value)}
              >
                <option value="">Todas</option>
                <option>Criou lote</option>
                <option>Validou contas</option>
                <option>Liberou pagamento</option>
                <option>Aprovou lote</option>
                <option>Rejeitou lote</option>
                <option>Adicionou conta</option>
              </select>
            </div>

            {(search || filterUser || filterAction) && (
              <button
                className="paylote-btn-secondary paylote-hist-clear-btn"
                onClick={() => { setSearch(""); setFilterUser(""); setFilterAction(""); }}
              >
                Limpar filtros
              </button>
            )}
          </div>
        </div>

        {/* Tabela */}
        <div className="paylote-table-card">
          <div className="paylote-hist-section-header">
            <TbHistory size={18} className="paylote-hist-section-icon" />
            <span className="paylote-hist-section-title">
              Registro de ações
            </span>
          </div>

          {(() => {
            if (loading) return (
              <div className="paylote-hist-empty">
                <p className="paylote-hist-empty-text">Carregando...</p>
              </div>
            );

            if (historico.length === 0) return (
              <div className="paylote-hist-empty">
                <TbHistory size={48} className="paylote-hist-empty-icon" />
                <p className="paylote-hist-empty-text">Nenhum registro encontrado.</p>
                <p className="paylote-hist-empty-sub">Tente ajustar os filtros acima.</p>
              </div>
            );

            return (
              <table className="paylote-table">
                <thead>
                  <tr>
                    <th>Data / Hora</th>
                    <th>Usuário</th>
                    <th>Ação</th>
                    <th>Detalhe</th>
                  </tr>
                </thead>
                <tbody>
                  {historico.map((r) => (
                    <tr key={r.id}>
                      <td className="paylote-hist-date-cell">{r.dataHora}</td>
                      <td>
                        <div className="paylote-payee-name">{r.usuario}</div>
                      </td>
                      <td>
                        <span className={`paylote-hist-acao-badge paylote-hist-acao-${ACTION_COLOR[r.acao] || 'blue'}`}>
                          {ACTION_ICONS[r.acao]} {r.acao}
                        </span>
                      </td>
                      <td className="paylote-hist-detalhe-cell">{r.detalhe}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
